import * as types from '../../actionTypes'

export const initialState = {
  netsuiteCustomer: {
    data: null,
    error: null,
    isLoading: false,
  },
  productUser: null,
  progressReport: {
    data: null,
    error: null,
    isLoading: false,
  },
  archetypes: {
    data: null,
    error: null,
    isLoading: false,
  },
  setupAdminUserId: null,
  isLoading: false,
  isSaving: false,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CLEAR_USERS: {
      return {
        ...state,
        error: null,
        productUser: null,
        setupAdminUserId: null,
        isLoading: false,
        isSaving: false,
      }
    }
    case types.FETCHING_PRODUCT_USER:
      return {
        ...state,
        isLoading: true,
      }
    case types.FETCHING_PRODUCT_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        productUser: action.productUser,
      }
    case types.FETCHING_PRODUCT_USER_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      }
    case types.FETCHING_SETUP_ADMIN_USER_ID:
      return {
        ...state,
        isLoading: true,
      }
    case types.FETCHING_SETUP_ADMIN_USER_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        setupAdminUserId: action.setupAdminUserId,
      }
    case types.FETCHING_SETUP_ADMIN_USER_ID_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      }
    case types.SAVING_PRODUCT_USER:
    case types.SAVING_PRODUCT_USER_SUCCESS:
    case types.SAVING_PRODUCT_USER_ERROR:
      return {
        ...state,
        error:
          action.type === types.SAVING_PRODUCT_USER_ERROR ? action.error : null,
        productUser:
          action.type === types.SAVING_PRODUCT_USER_SUCCESS
            ? action.productUser
            : null,
        isSaving: action.type === types.SAVING_PRODUCT_USER,
      }
    case types.SAVING_PRODUCT_USER_PAK_SUCCESS:
      return {
        ...state,
        isSaving: false,
      }

    case types.FETCHING_NETSUITE_CUSTOMER:
    case types.FETCHING_NETSUITE_CUSTOMER_ERROR:
    case types.FETCHING_NETSUITE_CUSTOMER_SUCCESS:
      return {
        ...state,
        netsuiteCustomer: {
          data:
            action.type === types.FETCHING_NETSUITE_CUSTOMER_SUCCESS
              ? action.netsuiteCustomer
              : null,
          error:
            action.type === types.FETCHING_NETSUITE_CUSTOMER_ERROR
              ? action.error
              : null,
          isLoading: action.type === types.FETCHING_NETSUITE_CUSTOMER,
        },
      }

    case types.FETCHING_LESSON_PROGRESS_REPORT:
    case types.FETCHING_LESSON_PROGRESS_REPORT_SUCCESS:
    case types.FETCHING_LESSON_PROGRESS_REPORT_ERROR:
      return {
        ...state,
        progressReport: {
          data:
            action.type === types.FETCHING_LESSON_PROGRESS_REPORT_SUCCESS
              ? action.sasUrl
              : null,
          error:
            action.type === types.FETCHING_LESSON_PROGRESS_REPORT_ERROR
              ? action.error
              : null,
          isLoading: action.type === types.FETCHING_LESSON_PROGRESS_REPORT,
        },
      }

    case types.FETCHING_ARCHETYPES:
    case types.FETCHING_ARCHETYPES_SUCCESS:
    case types.FETCHING_ARCHETYPES_ERROR:
      return {
        ...state,
        archetypes: {
          data:
            action.type === types.FETCHING_ARCHETYPES_SUCCESS
              ? action.archetypes
              : null,
          error:
            action.type === types.FETCHING_ARCHETYPES_ERROR
              ? action.error
              : null,
          isLoading: action.type === types.FETCHING_ARCHETYPES,
        },
      }

    default:
      return state
  }
}
